module.exports = __webpack_public_path__ + "static/create-remote-usability-tests-7c488c4fca73693002ab81b7c20fcf43.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/create-remote-usability-tests.png
// module id = 2679
// module chunks = 157636680307020